import React from 'react';
import { Link } from 'react-router-dom';
import { useCart } from '../context/CartContext';
import { getImageUrl } from '../utils/imageUrl';
import './Carrinho.css';

const Carrinho = () => {
  const { items, removeItem, updateQuantity, totalItems, totalPrice } = useCart();

  if (items.length === 0) {
    return (
      <div className="carrinho-page">
        <div className="container">
          <h1 className="page-title">Meu Carrinho</h1>
          <div className="carrinho-vazio">
            <p>Seu carrinho está vazio.</p>
            <Link to="/produtos" className="btn-secondary">Continuar comprando</Link>
          </div>
        </div>
      </div>
    );
  }

  return (
    <div className="carrinho-page">
      <div className="container">
        <h1 className="page-title">Meu Carrinho ({totalItems} {totalItems === 1 ? 'item' : 'itens'})</h1>
        <div className="carrinho-layout">
          <div className="carrinho-lista">
            {items.map(({ produto, quantidade, corSelecionada }) => {
              const fotoProduto = (produto.fotos && produto.fotos[0]) || produto.foto;
              const fotoCor = corSelecionada?.foto;
              const imageUrl = fotoCor ? getImageUrl(fotoCor) : (fotoProduto ? getImageUrl(fotoProduto) : null);
              const corKey = (corSelecionada?.descricao_cor ?? '').trim();
              const itemKey = `${produto.id}-${corKey}`;
              return (
                <div key={itemKey} className="carrinho-item">
                  <Link to={`/produto/${produto.id}`} className="carrinho-item-image">
                    {imageUrl ? (
                      <img src={imageUrl} alt={produto.nome} loading="lazy" />
                    ) : (
                      <div className="no-image">Sem imagem</div>
                    )}
                  </Link>
                  <div className="carrinho-item-info">
                    <Link to={`/produto/${produto.id}`} className="carrinho-item-nome">{produto.nome}</Link>
                    {corSelecionada?.descricao_cor && (
                      <p className="carrinho-item-cor">Cor: {corSelecionada.descricao_cor}</p>
                    )}
                    <p className="carrinho-item-preco">R$ {parseFloat(produto.preco).toFixed(2)}</p>
                    <div className="carrinho-item-actions">
                      <div className="quantity-control">
                        <button
                          type="button"
                          onClick={() => updateQuantity(produto.id, quantidade - 1, corKey)}
                          aria-label="Diminuir quantidade"
                        >
                          −
                        </button>
                        <span>{quantidade}</span>
                        <button
                          type="button"
                          onClick={() => updateQuantity(produto.id, quantidade + 1, corKey)}
                          aria-label="Aumentar quantidade"
                        >
                          +
                        </button>
                      </div>
                      <button
                        type="button"
                        className="btn-remove"
                        onClick={() => removeItem(produto.id, corKey)}
                      >
                        Remover
                      </button>
                    </div>
                  </div>
                  <div className="carrinho-item-subtotal">
                    R$ {(parseFloat(produto.preco) * quantidade).toFixed(2)}
                  </div>
                </div>
              );
            })}
          </div>
          <aside className="carrinho-resumo">
            <h3>Resumo</h3>
            <p className="resumo-total">Total: <strong>R$ {totalPrice.toFixed(2)}</strong></p>
            <Link to="/checkout" className="btn-checkout">Finalizar compra</Link>
            <Link to="/produtos" className="btn-continuar">Continuar comprando</Link>
          </aside>
        </div>
      </div>
    </div>
  );
};

export default Carrinho;
